import { useQuery } from "@tanstack/react-query";
import { getRecommendHeaderAdminPortal } from "../services/RecommendHeaderService";

export function useRecommendHeaderAdminPortal(fittingId) {
    const {data, isLoading, isError, error} = useQuery({
        queryKey: ["recommendHeader", fittingId],
        queryFn: () => getRecommendHeaderAdminPortal(fittingId),
        retry: false,
        staleTime: 1000 * 60 * 5,
        enabled: !!fittingId,
    });

    return {
        data,
        isLoading,
        isError,
        error,
    };
}
